import dayjs from 'dayjs';
import type HotelAndMarketService from 'lumen/services/hotel-and-market';
import {
  KPI_CATEGORIES,
  type KpiCategory,
} from 'lumen/utils/constants/ri-constant-values';
import getDateRange from 'lumen/utils/revenue-insight/get-date-range';

// Limit, over which we stop displaying rates data in the stayDate chart
const DATE_RANGE_LIMIT = 92;

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export default function isRatesAvailable(
  fromDate: string | null,
  toDate: string | null,
  hotelAndMarketService: HotelAndMarketService,
  activeFilters: string,
  stayDateFilter: string,
  kpiCategory: KpiCategory | null,
  hasRatesFeature = true,
) {
  const { dateRangeStart, dateRangeEnd } = getDateRange(
    fromDate,
    toDate,
    hotelAndMarketService,
    stayDateFilter,
  );
  // +1 because the end of the range should also count as a full day
  const isRangeOverLimit =
    dayjs.utc(dateRangeEnd).diff(dateRangeStart, 'day') + 1 > DATE_RANGE_LIMIT;
  const hasActiveFilters = activeFilters.length;
  const isGroupsSelected = kpiCategory
    ? kpiCategory === KPI_CATEGORIES.GROUP
    : false;

  return (
    hasRatesFeature &&
    !isRangeOverLimit &&
    !hasActiveFilters &&
    !isGroupsSelected
  );
}
